module.exports = __webpack_public_path__ + "img/project2.50b3f045.png";